export default __webpack_public_path__ + "static/media/withdraw-ecredit-step6.c0504a4a.png";